var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconNewsletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0EE09",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_1262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 14.5C29.2467 14.5 33.5 18.7533 33.5 24C33.5 29.2467 29.2467 33.5 24 33.5H14.5L17.2825 30.7175C15.5633 28.9983 14.5 26.6233 14.5 24C14.5 18.7533 18.7533 14.5 24 14.5ZM27.8 24.95H20.2C20.2 27.0486 21.9013 28.75 24 28.75C26.0986 28.75 27.8 27.0486 27.8 24.95Z",
    fill: "#A0EE09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_1262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconNewsletter);
export default __webpack_public_path__ + "static/media/menu-icon-newsletter.22e099a959c842b36d02654812c556ba.svg";
export { ForwardRef as ReactComponent };